module.exports = __webpack_public_path__ + "img/advantage4.c6659502.png";